/* eslint-disable */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Space } from 'antd';
import { useHistory, useLocation } from 'react-router';
import styled, { css } from 'styled-components';
import colors from '~/constants/colors';
import { CheckmarkIcon } from '~/img';
import { useSelectStep } from '~/controllers/wizard';
import { ApplicationStep } from '~/types/ApplicationStep';
import { useDirection } from '~/hooks/i18nHooks';

export interface ApplicationNavStepProps extends ApplicationNavStepStateProps {
  index: number;
  name: string;
  stepKey: any;
  // @ts-ignore
  uiKey: ApplicationStep['uiKey'];
  route: string;
  onClick?: () => void;
}

interface ApplicationNavStepStateProps {
  disabled: boolean;
  done: boolean;
  // validationError: boolean;
  active?: boolean;
  stageKey?: string;
}

const ApplicationNavStep: FC<ApplicationNavStepProps> = (props) => {
  const { index, name, route, stepKey, onClick, disabled, done, active, stageKey } = props;

  const history = useHistory();
  const location = useLocation();
  const selectStepMutation = useSelectStep();
  const { t } = useTranslation('ksaApplication');
  const dir = useDirection();
  const handleNavClick = async () => {
    if (onClick) {
      onClick();
    } else if (!disabled) {
      try {
        // Call selectStep API for all nav items so the backend tracks activeStep correctly.
        // Routing is handled by getActiveStepPath() in useSelectStep.onSuccess.
        if (stepKey === 'initialInformation') {
          // Initial Information is completed — clicking it should open Business Details
          await selectStepMutation.mutateAsync({
            stepKey: 'initialInformation',
            stageKey: 'ksaApplication',
          });
        } else if (stepKey === 'services') {
          // Select Products step
          await selectStepMutation.mutateAsync({ stepKey: 'services' });
        } else if (stepKey) {
          await selectStepMutation.mutateAsync({ stageKey, stepKey });
        } else {
          history?.push(route);
        }
      } catch (error) {
        //
      }
    }
  };

  return (
    <Container
      id={`ApplicationNavStep_${route}`}
      className="ApplicationNavStep"
      onClick={handleNavClick}
      disabled={disabled}
      done={done}
      dir={dir}
      // validationError={validationError}
      active={active ?? location.pathname === route}
    >
      <Space size={10} align="center">
        <div className="ApplicationNavStep-Index">
          {done ? (
            <CheckmarkIcon className="ApplicationNavStep-CheckmarkIcon" />
          ) : (
            <span>{index}</span>
          )}
        </div>
        <div className="ApplicationNavStep-Text">{t(name)}</div>
      </Space>
    </Container>
  );
};

const Container = styled.nav<ApplicationNavStepStateProps>`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: flex;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  .ApplicationNavStep-Index {
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    width: 24px;
    border-radius: 12px;
    border-width: 1.5px;
    border-style: solid;
    span {
      font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
      display: flex;
      font-weight: 600;
      font-size: 12px;
      color: white;
      vertical-align: middle;
    }
    .ApplicationNavStep-CheckmarkIcon {
      font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
      color: ${colors.componentBackground};
      font-size: 11px;
    }
    ${({ disabled, done }) =>
    disabled && done
      ? css`
            background-color: ${colors.doneColor};
            border-color: ${colors.disabledBlueTextColor};
            color: ${colors.disabledBlueTextColor} !important;
          `
      : disabled
        ? css`
            background-color: #4a4a4a !important;
            border-color: ${colors.disabledBlueTextColor};
            color: ${colors.disabledBlueTextColor} !important;
          `
        : css`
            border-color: ${colors.blue[1100]};
          `}
    ${({ active }) =>
    active
      ? css`
            background-color: ${colors.blue[1100]};
            color: ${colors.componentBackground};
          `
      : css`
            background-color: ${colors.blue[1100]};
            color: ${colors.blue[1100]};
          `}
    ${({ done }) =>
    done
      ? css`
            background-color: ${colors.doneColor};
            border-color: ${colors.doneColor};
            color: ${colors.componentBackground};
          `
      : css`
            //
          `}
  }
  .ApplicationNavStep-Text {
    white-space: nowrap;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    ${({ active }) =>
    active
      ? css`
            font-weight: 600;
          `
      : css``}

    ${({ disabled }) =>
    disabled
      ? css`
            color: ${colors.disabledUpComingTextColor};
          `
      : css`
            //
          `}
  }
`;

export default ApplicationNavStep;
